import { motion } from "framer-motion";
import { EASE } from "@/animations/motion";

interface ChartCardProps {
    title: string;
    accent: string;
    values: number[];
}

export function ChartCard({
    title,
    accent,
    values,
}: ChartCardProps) {
    return (
        <div className="rounded-2xl border border-border bg-card p-5">
            <div className="flex items-center justify-between">
                <h4 className="text-sm font-semibold text-foreground">
                    {title}
                </h4>

                <div
                    className="rounded-full px-2 py-1 text-xs font-semibold"
                    style={{
                        background: `${accent}15`,
                        color: accent,
                    }}
                >
                    Live
                </div>
            </div>

            <div className="mt-6 flex h-44 items-end gap-2">
                {values.map((value, index) => (
                    <motion.div
                        key={index}
                        initial={{
                            height: 0,
                        }}
                        animate={{
                            height: `${value}%`,
                        }}
                        transition={{
                            duration: 0.65,
                            delay: index * 0.05,
                            ease: EASE,
                        }}
                        className="flex-1 rounded-t-lg"
                        style={{
                            minHeight: 10,
                            background: `linear-gradient(to top,
                                ${accent},
                                ${accent}55
                            )`,
                        }}
                    />
                ))}
            </div>

            <div className="mt-4 grid grid-cols-7 text-center text-xs text-muted-foreground">
                <span>Jan</span>
                <span>Feb</span>
                <span>Mar</span>
                <span>Apr</span>
                <span>May</span>
                <span>Jun</span>
                <span>Jul</span>
            </div>
        </div>
    );
}